import script from "./EditTicketAnswerAction.vue?vue&type=script&setup=true&lang=js"
export * from "./EditTicketAnswerAction.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__